<template>
    <div>
        <div class="accordion accordion-toggle-arrow" id="userFilter">
            <div class="card" style="overflow:inherit">
                <div class="card-header bg-transparent" id="headingOne">
                    <div aria-controls="filterForm" class="card-title collapsed"
                         data-target="#filterForm"
                         data-toggle="collapse">
                        {{ $t('label.search') }}
                    </div>
                </div>
                <kt-panel>
                    <div aria-labelledby="filterForm" class="collapse" data-parent="#userFilter" id="filterForm">
                        <div class="card-body">
                            <form @submit.prevent="filterAction($event, query)">
                                <kt-form-section>
                                    <kt-form-row>
                                        <kt-col class="mb-2" md="3" sm="3" xs="12">
                                            <label for="type"
                                                   v-text="$t('label.type')"
                                            >
                                            </label>
                                            <select id="type" class="form-control" name="type" v-model="query.type"
                                            >
                                                <option v-for="(item, index) in transmitType" :key="index"
                                                        :value="item.value" :selected="item.value === null"
                                                        v-text="item.title"
                                                ></option>
                                            </select>
                                        </kt-col>
                                        <kt-col class="mb-2" md="3" sm="3" xs="12">
                                            <label for="bank_account"
                                                   v-text="$t('label.bank_account')"
                                            >
                                            </label>
                                            <select class="form-control" id="bank_account" name="bank_account"
                                                    v-model="query.number">
                                                <option :value="null" selected v-text="$t('label.default')"
                                                ></option>
                                                <option :key="index" :value="account.number"
                                                        v-for="(account, index) in mellat_banks"
                                                        v-text="account.number + ' (' + account.fa_name + ')'"
                                                >
                                                </option>
                                            </select>
                                        </kt-col>
                                        <kt-col class="mb-2" md="3" sm="3" xs="12">
                                            <label for="description"
                                                   v-text="$t('label.description')"
                                            >
                                            </label>
                                            <select id="description" class="form-control" name="description"
                                                    v-model="query.description"
                                            >
                                                <option :value="null" selected v-text="$t('label.all_types')"
                                                ></option>
                                                <option :value="transmitDescription.reversal"
                                                        v-text="transmitDescriptionStr.get(transmitDescription.reversal)"
                                                ></option>
                                            </select>
                                        </kt-col>
                                        <kt-col class="mb-2" md="3" sm="3" xs="12">
                                            <label for="from_date"
                                                   v-text="$t('label.amount')"
                                            >
                                            </label>
                                            <input
                                                id="amount"
                                                class="form-control"
                                                name="query.amount"
                                                v-model="query.amount"
                                            />
                                        </kt-col>
                                        <kt-col class="mb-2" md="4" sm="4" xs="12">
                                            <label for="from_date"
                                                   v-text="$t('label.ref_num')"
                                            >
                                            </label>
                                            <input
                                                id="ref_num"
                                                class="form-control"
                                                name="query.ref_num"
                                                v-model="query.ref_num"
                                            />
                                        </kt-col>
                                        <kt-col class="mb-2" md="4" sm="4" xs="12">
                                            <label for="from_date"
                                                   v-text="$t('label.from_date')"
                                            >
                                            </label>
                                            <button id="reset_from_date"
                                                    @click="clearFromDate"
                                                    type="button"
                                                    class=" btn btn-label-danger trash-btn"
                                            >
                                                <i class="la la-trash-o"></i>
                                            </button>
                                            <datePicker
                                                format="YYYY-MM-DD HH:mm:ss"
                                                display-format="dddd jDD jMMMM jYYYY HH:mm"
                                                input-class="form-control"
                                                id="from_date"
                                                :max="query.to_date"
                                                name="query.from_date"
                                                v-model="query.from_date"
                                                type="datetime"/>
                                        </kt-col>
                                        <kt-col class="mb-2" md="4" sm="4" xs="12">
                                            <label for="to_date"
                                                   v-text="$t('label.to_date')"
                                            >
                                            </label>
                                            <button id="reset_from_date"
                                                    @click="clearToDate"
                                                    type="button"
                                                    class=" btn btn-label-danger trash-btn"
                                            >
                                                <i class="la la-trash-o"></i>
                                            </button>
                                            <datePicker
                                                format="YYYY-MM-DD HH:mm:ss"
                                                display-format="dddd jDD jMMMM jYYYY HH:mm"
                                                input-class="form-control"
                                                id="to_date"
                                                :min="query.from_date"
                                                name="query.to_date"
                                                v-model="query.to_date"
                                                type="datetime"/>
                                        </kt-col>
                                    </kt-form-row>
                                    <div class="d-flex d-inline mt-2">
                                        <div class="mx-2">
                                            <button type="button" @click="requestStatement" class="btn btn-success btn-wide">{{$t('label.request_statement')}}</button>

                                        </div>
                                        <div class="mx-2">
                                            <button class="btn btn-dark btn-wide" :disabled="loading">
                                            <span>
                                              {{ $t('label.get_statement') }} <span
                                                v-if="timer != 0">{{ message }}</span>
                                            </span>
                                            </button>
                                        </div>
                                    </div>
                                </kt-form-section>
                            </form>
                        </div>
                    </div>
                    <div class="line-divider my-3"></div>
                    <div v-if="!loading">
                        <kt-panel-body>
                            <kt-datatable ref="datatable" v-bind="datatableProps">
                            </kt-datatable>
                        </kt-panel-body>
                    </div>
                    <div v-else>
                        <div class="text-center p-3 text-white-in-dark-mode" style="background-color: transparent;">
                            <div class="spinner-border text-success" role="status"></div>
                            <span class="p-2">لطفا صبر کنید</span>
                        </div>
                    </div>
                </kt-panel>
            </div>
        </div>
    </div>
</template>

<script>
import {i18n} from "@/plugins/i18n";
import {ApiUrl, walletService} from "@/common/api.service";
import {transmitDescription, transmitDescriptionStr} from "@/constants/transmitDescription";
import {AuthorizationHeader} from "@/common/jwt.service";
import MellatColumns from "@/views/wallets/AyandeWallets/Admin/components/statements/columns/mellat-columns";
import Loading from "../../../../../../components/custom/loading.vue";
import Progress from "../../../../../../components/elements/progress.vue";

export default {
    props: {
        fetch_starshop: {
            default: false,
            type: Boolean
        },
        api_base_path: {
            default: ApiUrl.path(''),
            type: String
        }
    },
    name: "mellat",
    components: {Progress, Loading},
    computed: {
        datatableProps() {
            if (this.loading) return ;
            return {
                id: 'saman_statement_report_datatable',
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url: this.api_base_path + 'wallet/common/admin/get-mellat-statements',
                            method: 'GET',
                            headers: AuthorizationHeader,
                            map: res => {
                                return res.data.data;
                            },
                            params: {
                                query: this.query,
                            },
                        }
                    },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                layout: {},
                pagination: false,
                sortable: true,
                columns: MellatColumns,
            }
        },


        transmitDescription() {
            return transmitDescription
        },
        transmitDescriptionStr() {
            return transmitDescriptionStr
        }
    },
    data() {
        return {
            transmitType: [
                {title: i18n.t('label.all_types'), value: null},
                {title: i18n.t('label.credit'), value: 'CREDIT'},
                {title: i18n.t('label.debit'), value: 'DEBIT'},
            ],
            mellat_banks: [],
            loading: false,
            query: {
                type: null,
                description: null,
                number: null,
            },
            timer: 0,
            message: null,
            interval: null,

        }
    },
    mounted() {
        const mellatBankAccounts = this.fetch_starshop
            ? walletService.getStarShopAllWalletMellatBanks
            : walletService.getAllWalletMellatBanks;

        mellatBankAccounts().then(res => {
            this.mellat_banks = res.data.data.all_mellat_bank_accounts;
        });

        this.requestStatement();
    },

    methods: {
        requestStatement() {
            this.loading = true;

            const mellatStatements = this.fetch_starshop
                ? walletService.requestStarShopMellatStatements
                : walletService.requestMellatStatements;

            mellatStatements(this.query).then(
                response => {
                    this.toastr.success(response.data.message)
                    clearInterval(this.interval);
                    this.startTime();
                }
            ).catch(async ({response}) => {
                this.loading = false;
                this.toastr.error(response.data.message)
            })

        },

        startTime() {
            this.timer = 60;
            this.interval = setInterval(this.downCount, 1000);
        },
        downCount() {
            if (this.timer >= 0) {
                this.timer -= 1;
                let min = parseInt(this.timer / 60);

                let sec = parseInt(this.timer % 60);
                this.message = `${this.pad(min)}:${this.pad(sec)}`
                console.log(this.timer)
            }
            if (this.timer <= 0) {
                this.loading = false;
                clearInterval(this.interval);
            }
        },
        clearFromDate() {
            if (this.query.from_date) {
                this.query.from_date = null
            }
        },
        clearToDate() {
            if (this.query.to_date) {
                this.query.to_date = null
            }
        },
        filterAction(e, query) {

            this.query = query;

            if (this.$refs.datatable.KTDatatable) {
                this.$refs.datatable.reload();
            }
        },

    },
}
</script>

<style scoped>
.loader {
    border: 16px solid #f3f3f3;
    border-radius: 50%;
    border-top: 16px solid #3498db;
    width: 120px;
    height: 120px;
    -webkit-animation: spin 2s linear infinite forwards !important; /* Safari */
    animation: spin 2s linear infinite forwards;
}

/* Safari */
@-webkit-keyframes spin {
    0% {
        -webkit-transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(360deg);
    }
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

.loader-div {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
}
</style>